import React from 'react';
import { Sparkles } from 'lucide-react';
import AgentCard from './AgentCard';
import ActivityFeed from './ActivityFeed';
import SessionList from './SessionList';
import { AGENT_PERSONAS } from '../constants';
import type { BrandTeamSession, BrandTeamAgentRun, BrandTeamAgentLog, BrandTeamAgentArtifact } from '../../../../services/brandTeamService';

interface AgentPanelProps {
  agentRuns: BrandTeamAgentRun[];
  agentArtifacts: BrandTeamAgentArtifact[];
  agentLogs: BrandTeamAgentLog[];
  sessions: BrandTeamSession[];
  activeSessionId: string | null;
  onSelectSession: (id: string) => void;
}

const AgentPanel: React.FC<AgentPanelProps> = ({
  agentRuns, agentArtifacts, agentLogs, sessions, activeSessionId, onSelectSession,
}) => {
  const runMap = new Map(agentRuns.map((r) => [r.agentKey, r]));
  const artifactMap = new Map(agentArtifacts.map((a) => [a.agentRunId, a]));

  const doneCount = AGENT_PERSONAS.filter((p) => runMap.get(p.agentKey)?.status === 'completed').length;

  return (
    <div className="flex h-full w-full flex-col bg-white">
      {/* Header */}
      <div className="flex items-center justify-between border-b border-primary-100 px-4 py-3.5">
        <div className="flex items-center gap-2">
          <Sparkles className="h-4 w-4 text-brand-purple" />
          <h3 className="font-heading text-sm font-bold text-text-dark">Your AI Team</h3>
        </div>
        <span className="rounded-full bg-green-50 px-2.5 py-0.5 text-[10px] font-semibold text-green-600">
          {doneCount}/{AGENT_PERSONAS.length} done
        </span>
      </div>

      {/* Agent cards */}
      <div className="flex-1 space-y-1.5 overflow-y-auto px-3 py-3">
        {AGENT_PERSONAS.map((persona) => {
          const run = runMap.get(persona.agentKey);
          const artifact = run ? artifactMap.get(run.id) : undefined;
          return <AgentCard key={persona.agentKey} persona={persona} run={run} artifact={artifact} />;
        })}
      </div>

      {/* Activity feed */}
      <ActivityFeed logs={agentLogs} />

      {/* Sessions */}
      <SessionList sessions={sessions} activeSessionId={activeSessionId} onSelect={onSelectSession} />
    </div>
  );
};

export default AgentPanel;
